import React, { FC } from "react"
import { EncryptedGuardianSignature } from "../../../models/api-models/guardians/guardian-form-submission"
import moment from "moment"

 interface GuardiansListItemsProps {
    guardian: EncryptedGuardianSignature
}

export const GuardiansListItem: FC<GuardiansListItemsProps> = ({ guardian }) => {
    const formatedDate = moment(guardian.signatureDate).format('MM/DD/YYYY');
    return (
        <div className="guardian-block">
            <div className="guardian-block-header">
                <span className="guardian-block-name">{guardian.fullName}</span>
                <span className="guardian-block-date">{formatedDate}</span>
            </div>
            <div className="guardian-block-email">{guardian.email}</div>
        </div>
    )
}